import { createAction, props } from "@ngrx/store";
import { User } from "../../models/user.model";

export const loadCurrentUser = createAction("[Current User Component] Load Current User");

export const loadedCurrentUser = createAction(
    "[Current User Component] Loaded Current User",
    props<{ user: User }>(),
);
